import MapFeature from './MapFeature'

/**
 * Adds source and layer(s) in order to display content on the map.
 */
export default class MapContent extends MapFeature {

    /** @type {string} */
    _id

    /** @type {import("maplibre-gl").AnySourceData} */
    _source

    /** @type {import("maplibre-gl").AnyLayer[]} */
    _layers

    /** @type {string[]} */
    _layerIds = []

    /**
     * @param {string} id ID for source and layer
     * @param {import("maplibre-gl").AnySourceData} source
     * @param {...import("maplibre-gl").AnyLayer[]} layers
     */
    constructor(id, source, ...layers) {
        super()

        this._id = id
        this._source = source
        this._layers = layers

        this._handleMapStyleChange = this._handleMapStyleChange.bind(this)
    }

    /**
     * Replace the GeoJSON data in the source.
     * @param {Object} data
     */
    setData(data) {
        this._source.data = data
        if (this._map) {
            const source = this._map.getSource(this._id)
            if (!source) return
            source.setData(data)
        }
    }

    /** @type {string[]} */
    get layerIds() { return this._layerIds }

    /** @type {Object} */
    get data() { return this._source.data }

    _onAdd(map) {
        this._addSourceAndLayer()

        map.on('styledata', this._handleMapStyleChange)
    }

    _onRemove(map) {
        map.off('styledata', this._handleMapStyleChange)

        for (const layer of this._layers) {
            map.removeLayer(layer.id || this._id)
        }
        map.removeSource(this._id)

        this._layerIds = []
    }

    _addSourceAndLayer() {
        this._map.addSource(this._id, this._source)

        for (const layerConfig of this._layers) {
            const layer = {
                id: this._id,
                ...layerConfig,
                source: this._id,
            }
            this._map.addLayer(layer)
            this._layerIds.push(layer.id)
        }
    }

    _handleMapStyleChange() {
        // We need to add the route source & layer again if new map style was applied
        if (!this._map.getSource(this._id)) {
            this._addSourceAndLayer()
        }
    }

}
